import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.5",
      d: "M9 16h10M9 10h10M9 4h10"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2.68 9V3.28l-1.35.83v-1.5l1.35-.81h1.39V9zM.482 18.99v-1.18l3.02-2.68q.34-.3.48-.565t.14-.495q0-.33-.135-.585a1 1 0 0 0-.38-.405 1.1 1.1 0 0 0-.575-.15q-.345 0-.61.16a1.1 1.1 0 0 0-.405.415q-.144.255-.135.555h-1.4q0-.74.325-1.28a2.2 2.2 0 0 1 .905-.835q.58-.295 1.35-.295.705 0 1.26.31.56.305.88.855t.32 1.275q0 .535-.15.89-.15.35-.445.65-.294.295-.725.67l-1.95 1.71-.11-.3h3.38v1.28z"
    }, null, -1)
  ]))]))
}
export default { render: render }